import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { myProfile, saveMyProfile } from "../../api/profile";
import { useAuth } from "../../context/AuthContext";

const empty = {
  nationality: "", birth_date: "", gender: "", marital_status: "", national_id: "",
  national_id_expiry: "", national_id_file: "", passport_number: "", passport_expiry: "",
  passport_file: "", address: "", iban: "", emergency_name: "", emergency_phone: "",
};

export const useProfileWizard = () => {
  const { t } = useTranslation();
  const { patchUser } = useAuth();
  const [phone, setPhone] = useState("");
  const [personal, setPersonalState] = useState(empty);
  const [missing, setMissing] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    myProfile()
      .then((data) => {
        setPhone(data.profile.phone || "");
        setPersonalState({ ...empty, ...(data.profile.personal || {}) });
        setMissing(data.missing);
      })
      .finally(() => setLoading(false));
  }, []);

  const setPersonal = (key, value) => setPersonalState((p) => ({ ...p, [key]: value }));

  const save = async () => {
    setBusy(true);
    try {
      const res = await saveMyProfile({
        phone,
        personal: Object.fromEntries(Object.entries(personal).filter(([, v]) => v !== "" && v !== null)),
      });
      setMissing(res.missing);
      if (!res.missing.length) {
        patchUser({ status: res.status });
        toast.success(t("profile.completed"));
        window.location.replace("/");
        return;
      }
      toast.error(t("profile.stillMissing", { count: res.missing.length }));
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(detail?.code ? t(`personal.errors.${detail.code}`, { ...detail, defaultValue: t("errors.generic") }) : t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return { phone, setPhone, personal, setPersonal, missing, loading, busy, save };
};
